export default "__VITE_ASSET__Cuwod$VW__"